const translations = {
    selected: '({{count}}/{{total}}) Selected'
};

export default translations;
